import { ipsos, supuesto } from ".";

// Lámina 68 (base 400 general / 311 usuarios de delivery).
const P_USA = "¿Usa aplicaciones de delivery de comida?";
const P_APP = "¿Cuál es su app de delivery preferida?";
const P_TIPO = "¿Qué tipo de producto pide por delivery?";
const P_FRECUENCIA = "¿Con qué frecuencia pide delivery?";

export const IPSOS_DELIVERY = {
  usaDelivery: ipsos(0.769, { lamina: 68, pregunta: P_USA, base: 400 }),
  noUsaDelivery: ipsos(0.231, { lamina: 68, pregunta: P_USA, base: 400 }),

  apps: {
    "Uber Eats": ipsos(0.586, { lamina: 68, pregunta: P_APP, base: 311 }),
    "Pedidos Ya": ipsos(0.264, { lamina: 68, pregunta: P_APP, base: 311 }),
    Rappi: ipsos(0.15, { lamina: 68, pregunta: P_APP, base: 311 }),
  },

  // No se usa en ningún cálculo hoy (dato Ipsos muerto, se preserva igual que en el código actual)
  tipoProducto: {
    comida: ipsos(0.903, { lamina: 68, pregunta: P_TIPO, base: 311 }),
    supermercado: ipsos(0.097, { lamina: 68, pregunta: P_TIPO, base: 311 }),
  },

  // factor = pedidos/mes (supuesto comercial derivado de la etiqueta de frecuencia Ipsos)
  frecuenciaUso: {
    todosLosDias: {
      pct: ipsos(0.014, { lamina: 68, pregunta: P_FRECUENCIA, base: 311 }),
      factor: supuesto(30, { nota: "pedidos/mes" }),
    },
    finesDeSemana: {
      pct: ipsos(0.075, { lamina: 68, pregunta: P_FRECUENCIA, base: 311 }),
      factor: supuesto(8, { nota: "pedidos/mes" }),
    },
    variosDiasSemana: {
      pct: ipsos(0.067, { lamina: 68, pregunta: P_FRECUENCIA, base: 311 }),
      factor: supuesto(12, { nota: "pedidos/mes" }),
    },
    unaVezSemana: {
      pct: ipsos(0.273, { lamina: 68, pregunta: P_FRECUENCIA, base: 311 }),
      factor: supuesto(4, { nota: "pedidos/mes" }),
    },
    cadaDosSemananas: {
      pct: ipsos(0.297, { lamina: 68, pregunta: P_FRECUENCIA, base: 311 }),
      factor: supuesto(2, { nota: "pedidos/mes" }),
    },
    cadaTresSemanas: {
      pct: ipsos(0.08, { lamina: 68, pregunta: P_FRECUENCIA, base: 311 }),
      factor: supuesto(1.3, { nota: "pedidos/mes" }),
    },
    unaVezMes: {
      pct: ipsos(0.18, { lamina: 68, pregunta: P_FRECUENCIA, base: 311 }),
      factor: supuesto(1, { nota: "pedidos/mes" }),
    },
    menosDeUnaVezMes: {
      pct: ipsos(0.014, { lamina: 68, pregunta: P_FRECUENCIA, base: 311 }),
      factor: supuesto(0.5, { nota: "pedidos/mes" }),
    },
  },

  // Gasto declarado por el resumen Ipsos (lámina 16) — solo texto del disclaimer, sin badge
  gastoPromedioMensual: {
    min: ipsos(80000, { lamina: 16, pregunta: "Gasto promedio mensual en delivery", base: 400 }),
    max: ipsos(150000, { lamina: 16, pregunta: "Gasto promedio mensual en delivery", base: 400 }),
    promedio: ipsos(115000, { lamina: 16, pregunta: "Gasto promedio mensual en delivery", base: 400 }),
  },
};

// Supuestos comerciales — ticket promedio (CLP, "basado en experiencia real del usuario")
export const TICKETS_PROMEDIO_DELIVERY = [
  supuesto(8000, { nota: "ticket promedio" }),
  supuesto(12000, { nota: "ticket promedio" }),
  supuesto(15000, { nota: "ticket promedio" }),
  supuesto(20000, { nota: "ticket promedio" }),
];

export const ESCENARIOS_CAPTACION_DELIVERY = [
  supuesto(5, { nota: "escenario de captación de mercado" }),
  supuesto(10, { nota: "escenario de captación de mercado" }),
  supuesto(20, { nota: "escenario de captación de mercado" }),
];
